import { BaseModel } from "model/BaseModel";

export default class Processo implements BaseModel{
    id: number | null;
    codigo: string | null;
    codigoInterno: number;
    nome: string;

    constructor(
        id  = 0,
        codigo = null,
        codigoInterno = 0,
        nome = ''
    ){
        this.id = id;
        this.codigo = codigo;
        this.codigoInterno = codigoInterno;
        this.nome = nome;
    }
}